define('viewmodels/pages/cash/TransactionListViewModel',['knockout'], function (ko) {

    var TransactionListViewModel = function (
        navigation,
        getField,
        getDepositField,
        dialog,
        showError,
        TransactionHistoryDialog,
        receiptContent,
        transactions)
    {
        var self = this;

        self.transactions = transactions;

        self.iconCssClass = function(transaction) {
            var cssClass;
            if (transaction.isPendingWithdraw()) {
                cssClass = 'icons-pending color-grey';
            }
            else if (transaction.isRolledBack()) {
                cssClass = 'icons-exclamation-mark color-grey';
            }
            else if (transaction.isDone()) {
                cssClass  = 'icons-tick color-green';
            }
            return cssClass;
        };

        self.showReceipt = function(transaction) {
            dialog.showDialog(new TransactionHistoryDialog(transaction));
        };

        self.title = getField('title');
        self.noTransactionsText = getField('no_transactions_text');
        self.cancelText = getField('cancel_withdrawal_cta_text');

        self.reasonText = function(transaction) {
            var reasonText;
            if (transaction.isPendingWithdraw()) {
                reasonText = getField('pending_withdrawal_label');
            } else if (transaction.isDeposit()) {
                reasonText = getField('deposit_label');
            } else {
                reasonText = getField('withdrawal_label');
            }

            return reasonText;
        };

        self.compositionComplete = function() {
            // preload this as it needs to be loaded before a receipt dialog is loaded to prevent the dialog loading jankily
            receiptContent.load();
        };

        self.cancelWithdrawal = function (withdrawalTransaction) {
            return withdrawalTransaction.cancel().done(function () {
                navigation.navigate(navigation.ROUTES.GAMES);
            }).fail(function () {
                showError(
                    getDepositField('cancelling_withdrawal_failed_error_message'),
                    getDepositField('cancelling_withdrawal_failed_error_title'));
            });
        };
    };

    return TransactionListViewModel;
});


